import {createAsyncThunk} from "@reduxjs/toolkit";
import request from "../../../../service";
import {IErrorResponse} from "../../../../types";
import {IAcademicSchedulingCreate} from "../types";
import {
    deletedAcademicScheduling,
    deletedRestoreAcademicScheduling,
    setAcademicScheduling, setAcademicSchedulingRestore,
    updateAcademicScheduling
} from "./academicSchedulingSlice";

const GetAcademicScheduling= createAsyncThunk(
    "get/academic/hours",
    async (_, { dispatch,rejectWithValue }) => {
        try {
            const response = await request.get("/academic-hours");

            dispatch(setAcademicScheduling(response.data));
            return response.data;
        }  catch (error) {
            const typedError = error as IErrorResponse;
            return rejectWithValue(typedError.response.data.message || "unexpected_fail");
        }
    }
);
const SetAcademicScheduling= createAsyncThunk(
    "create/academic/hours",
    async ( data:IAcademicSchedulingCreate ,{rejectWithValue}) => {
        try {
            const response = await request.post("/academic-hours", data);
            return response.data;
        }  catch (error) {
            const typedError = error as IErrorResponse;
            return rejectWithValue(typedError.response.data.message || "unexpected_fail");

        }
    }
);
const EditAcademicScheduling = createAsyncThunk(
    "edit/academic/hours",
    async ( data :any, { dispatch, rejectWithValue }) => {
        try {
            const response = await request.put(`/academic-hours/${data.id}`, data);
            dispatch(updateAcademicScheduling(response.data));
            return response.data;
        } catch (error) {
            const typedError = error as IErrorResponse;
            return rejectWithValue(typedError.response.data.message || "unexpected_fail");
        }
    }
);

const DeleteAcademicScheduling= createAsyncThunk(
    "delete/academic/hours",
    async (id:number, { dispatch,rejectWithValue }) => {
        try {
            const response = await request.delete(`/academic-hours/${id}`);
            dispatch(deletedAcademicScheduling(id));
            return response.data;
        } catch (error) {
            const typedError = error as IErrorResponse;
            return rejectWithValue(typedError.response.data.message || "unexpected_fail");
        }
    }
);

const GetDeleteAcademicScheduling = createAsyncThunk(
    "get/delete/academic/hours",
    async (_,{ dispatch,rejectWithValue }) => {
        try {
            const response = await request.get(`/academic-hours/deleted-items`);
            dispatch(setAcademicSchedulingRestore(response.data));
            return response.data;
        } catch (error) {
            const typedError = error as IErrorResponse;
            return rejectWithValue(typedError.response.data.message || "unexpected_fail");
        }
    }
);
const RestoreDeleteAcademicScheduling= createAsyncThunk(
    "restore/delete/academic/hours",
    async (id:number,{ dispatch,rejectWithValue }) => {
        try {
            const response = await request.post(`/academic-hours/restore/${id}`);
            dispatch(deletedRestoreAcademicScheduling(id));

            return response.data;
        }  catch (error) {
            const typedError = error as IErrorResponse;
            return rejectWithValue(typedError.response.data.message || "unexpected_fail");
        }
    }
);

export{
    GetAcademicScheduling,
    SetAcademicScheduling,
    EditAcademicScheduling,
    DeleteAcademicScheduling,
    GetDeleteAcademicScheduling,
    RestoreDeleteAcademicScheduling
}